import React, { type ReactNode, useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { SimpleSpinner } from '../../../SimpleSpinner';

import { Action, IconWrapper, Label } from './ProviderAction.style';

export interface ProviderActionProps {
    // icon?: SvgIconComponent;
    icon?: ReactNode;
    label?: string;
    ariaLabel?: string;
    large?: boolean;
    onAction?: () => void;
    onAsyncAction?: () => Promise<void>;
}

export function ProviderAction({
    icon,
    label,
    ariaLabel,
    large = false,
    onAction,
    onAsyncAction,
}: ProviderActionProps) {
    const [loading, setLoading] = useState(false);

    function handlePromise() {
        if (!onAsyncAction) return;
        setLoading(true);
        onAsyncAction().finally(() => setLoading(false));
    }

    // const Icon = icon ?? Fragment;
    const iconMarkup = icon ? <IconWrapper>{icon}</IconWrapper> : null;
    const labelMarkup = label?.length ? <Label>{label}</Label> : null;
    const spinnerMarkup = loading ? <SimpleSpinner key="ProviderAction-Spinner" size={large ? 24 : undefined} /> : null;

    return (
        <Action
            $iconOnly={Boolean(iconMarkup && !labelMarkup)}
            $large={large}
            ariaLabel={ariaLabel}
            disabled={loading}
            onAction={onAsyncAction ? handlePromise : onAction}
        >
            {iconMarkup}
            {labelMarkup}

            <AnimatePresence>{spinnerMarkup}</AnimatePresence>
        </Action>
    );
}
